import React, { useState } from "react";
import PropTypes from "prop-types";

const AvailableTimesDialog = ({
  entity = {},
  closeDialog,
  handleSaveAvailableTimes,
}) => {
  const { availableTimes = [], firstName = "", lastName = "" } = entity;

  const days = [
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ];
  const hours = Array.from({ length: 12 }, (_, i) => 10 + i); // 10–21 Uhr

  const [selectedTimes, setSelectedTimes] = useState(availableTimes);

  const toggleTimeSelection = (day, hour) => {
    const time = `${day} ${hour}`;
    setSelectedTimes((prev) =>
      prev.includes(time) ? prev.filter((t) => t !== time) : [...prev, time]
    );
  };

  return (
    <div className="available-times-overlay">
      <div className="available-times-dialog">
        <h3>
          Trainingszeiten für {firstName} {lastName} bearbeiten
        </h3>

        <div className="days-container">
          {days.map((day) => (
            <div key={day} className="day-row">
              <h4>{day}</h4>
              <div className="hours-container">
                {hours.map((hour) => {
                  const time = `${day} ${hour}`;
                  const isSelected = selectedTimes.includes(time);
                  return (
                    <label key={time} className="hour-label">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => toggleTimeSelection(day, hour)}
                      />
                      {hour}:00
                    </label>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        <div className="dialog-buttons">
          <button onClick={() => handleSaveAvailableTimes(selectedTimes)}>
            Speichern
          </button>
          <button onClick={closeDialog}>Abbrechen</button>
        </div>
      </div>
    </div>
  );
};

AvailableTimesDialog.propTypes = {
  entity: PropTypes.shape({
    availableTimes: PropTypes.arrayOf(PropTypes.string),
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  closeDialog: PropTypes.func.isRequired,
  handleSaveAvailableTimes: PropTypes.func.isRequired,
};

export default AvailableTimesDialog;